import { EmailTemplate } from "../data/EmailTemplate";
import { ApiResponse, callApi } from "./ApiUtilities";

export async function getEmailTemplates(): Promise<ApiResponse<EmailTemplate[]>> {
  return callApi<EmailTemplate[]>("/api/emailtemplates", "GET");
}

export async function getEmailTemplate(type: string): Promise<ApiResponse<EmailTemplate>> {
  return callApi<EmailTemplate>(`/api/emailtemplates/${type}`, "GET");
}

export async function saveEmailTemplate(type: string, template: EmailTemplate): Promise<ApiResponse<EmailTemplate>> {
  return callApi<EmailTemplate>(`/api/emailtemplates/${type}`, "POST", template);
}

/** Sends an email to all enabled attendees. Returns the number queued. */
export async function sendEmailToAllUsers(subject: string, contentHtml: string): Promise<ApiResponse<number>> {
  return callApi<number>("/api/useradmin/emailall", "POST", { subject: subject, contentHtml: contentHtml });
}

/** Generates a password reset for a user: emails them and returns the link. */
export async function generateResetLink(username: string): Promise<ApiResponse<string>> {
  return callApi<string>("/api/useradmin/resetlink", "POST", { username: username });
}
